import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import NoData from "src/assets/images/dashboard/no-data.jpg";

interface Props {
  autoHeight?: boolean;
  text?: string;
}

const index: React.FC<Props> = ({ autoHeight, text }) => {
  return (
    <Box
      sx={{
        height: autoHeight ? "auto" : "100%",
        flexDirection: "column",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <img src={NoData} alt="" style={{ height: "100px", width: "100px" }} />
      <Typography
        sx={{
          fontSize: "14px",
          color: "#999",
          textTransform: "capitalize",
        }}
      >
        {!text ? "No record found" : text}
      </Typography>
    </Box>
  );
};

export default index;
